/**
 * Current shell version.
 *
 * This constant defines the shell version that all module bundles must
 * declare compatibility with. Modules reference this value in their
 * ModuleDefinition to ensure they are built against a compatible shell.
 *
 *
 * Modules are organized on the CDN by shell version:
 * `modules/{moduleId}/shell-{shellVersion}/{moduleVersion}.js`
 *
 * @example
 * ```ts
 * import { SHELL_VERSION } from '@bestowinc/tinkertoy-shell-deps';
 *
 * export const myModule = defineModule({
 *   id: 'my-module',
 *   version: '1.0.0',
 *   shellVersion: SHELL_VERSION, // Type-safe reference to current shell version
 *   // ...
 * });
 * ```
 */
export const SHELL_VERSION = "1" as const;

/**
 * Type representing the current shell version.
 *
 * This is a branded string literal type that ensures modules
 * explicitly reference the shell version constant rather than
 * arbitrary strings.
 */
export type CurrentShellVersion = typeof SHELL_VERSION;

